/**
 * Created by lenovo on 2017/12/6.
 */

import Lazy from './lazyImage';

export default Lazy;


// WEBPACK FOOTER //
// ./src/utils/lazyImage/index.js